/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/*
 * Split arrays into random train and test subsets
 * using seeded random number generator
 *
 */
export function splitTrainValidation(x, y, val_ratio) {
	let xTrain = [];
	let yTrain = [];
	let xVal = [];
	let yVal = [];
	let seed = 1;
	if (x.length != y.length) {
		throw new Error('Sizes of input arguments do not match' + x.length + ' and ' + y.length)
	}
	x.map((v, idx) => {
		let rand = Math.sin(seed++) * 10000;
		rand = rand - Math.floor(rand);
		if (rand < val_ratio) {
			xVal.push(v);
			yVal.push(y[idx]);
		} else {
			xTrain.push(v);
			yTrain.push(y[idx]);
		}
	});
	/*
	In case x and y are small or val_ratio is close to 0 or 1, 
	some of the arrays could be empty. To avoid this, 
	the first row is added to empty arrays
	*/
	if (yTrain.length == 0) {
		xTrain.push(x[0])
		yTrain.push(y[0])
	}
	if (yVal.length == 0) {
		xVal.push(x[0])
		yVal.push(y[0])
	}

	return {
		xTrain: xTrain,
		yTrain: yTrain,
		xVal: xVal,
		yVal: yVal
	};
}